<template>
  <div class="motion-box">
    <div class="motion-box__container" />
  </div>
</template>

<script>
export default {
  name: 'MotionBox',
  data() {
    return {
      baseImages: {
        col1: [
          '/theme/rbFront/img/w/mediaArtSolution/about_piece01.jpg',
          '/theme/rbFront/img/w/mediaArtSolution/about_piece02.jpg',
          '/theme/rbFront/img/w/mediaArtSolution/about_piece03.jpg'
        ],
        col2: [
          '/theme/rbFront/img/w/mediaArtSolution/about_piece04.jpg',
          '/theme/rbFront/img/w/mediaArtSolution/about_piece05.jpg',
          '/theme/rbFront/img/w/mediaArtSolution/about_piece06.jpg'
        ],
        col3: [
          '/theme/rbFront/img/w/mediaArtSolution/about_piece07.jpg',
          '/theme/rbFront/img/w/mediaArtSolution/about_piece08.jpg',
          '/theme/rbFront/img/w/mediaArtSolution/about_piece09.jpg'
        ]
      },
      animationFrameId: null,
      columnHeights: {
        col1: 0,
        col2: 0,
        col3: 0
      },
      // 각 컬럼의 transition 상태를 관리
      isTransitioning: {
        col1: false,
        col2: false,
        col3: false
      }
    }
  },
  mounted() {
    this.startAnimation();
  },
  beforeDestroy() {
    this.stopAnimation()
  },
  methods: {
    startAnimation() {
    },
    stopAnimation() {
    },
  }
}
</script>

<style lang="scss" scoped>
@keyframes scroll {
  to {
    background-position: 0 100%;
  }
}

.motion-box {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;

  &__container {
    width: 120.41666667%;
    height: 120.41666667%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    object-fit: cover;
    box-sizing: border-box;
    overflow: hidden;
    background: url('/theme/rbFront/img/w/mediaArtSolution/about01.png') repeat-y;
    background-size: 100% auto;
    animation: scroll 13s linear infinite;
  }
  &__image {
    width: 100%;
  }
}
</style>